import Vue from 'vue';
import Vuex from 'vuex';

/* import {HTTP} from '../http-common';
import EventBus from "../components/event-bus";
import {commonMixins} from '../mixins/commonMixins'; */
import EventBus from "../components/event-bus";

Vue.use(Vuex);

export const store = new Vuex.Store({
    // mixins: commonMixins,
    state: {
       pusher: '',
    },
    mutations: {
        changePusherObj(state, pusher){
            state.pusher = pusher;
        },
    },
    actions: {
        loadPusherObj: function (context) {
            var self = context;
            // self.pusher = new Pusher('48e44077269fc26fa1d6', {
            self.pusher = new Pusher(process.env.PUSHER_KEY, {
                cluster: process.env.PUSHER_APP_CLUSTER,
            });

            EventBus.$emit("get-pusher-obj", self.pusher);
        },
    },
    getters: {
        pusher: state => state.pusher,
    }
});


// WEBPACK FOOTER //
// ./src/store/store.js